import {
  BaseModel,
  DeviceSoftwareStatus,
  MaintenanceStatus,
} from '@nimmsta/ng-commons-lib/models';
import dayjs from 'dayjs';
import { CareArticle } from './care-article.model';

export { MaintenanceStatus };

export enum ConnectionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface SimpleScanner extends BaseModel {
  uniqueIdentifier: string;

  address: string;

  lastConnection: Date;

  connectionStatus: ConnectionStatus;

  lastWorkerName: string;

  lastConnectedHandheldId?: string;

  warrantyBaseEndDate?: dayjs.Dayjs;

  warrantyFullEndDate?: dayjs.Dayjs;

  careArticles?: CareArticle[];

  maintenanceStatus?: MaintenanceStatus;

  isDataUpToDate?: boolean;

  isBatteryOk?: boolean;

  isScanEngineOk?: boolean;

  firmwareBundleName?: string;

  firmwareBundleVersion?: string;

  firmwareBundleIdentified?: boolean;

  imagerFirmwareUpdateRequired?: boolean;

  firmwareBundleLatestVersion?: string;

  softwareStatus?: DeviceSoftwareStatus;

  firmwareUpdateRequested?: boolean;

  listStatusSummary?: string;

  locationOrganizationId?: string;
}

export interface Scanner extends SimpleScanner {
  batteryHealthPercent?: number;

  displayedChargingCycles?: number;

  batteryHealthWarning?: boolean;

  chargingCyclesWarning?: boolean;
}
